import * as _ from 'lodash'
import { Table, THead, TR, TH, TD, A, TBody, Div, VArray, Span, ElementProperties, not, if as _if } from 'alkali'
import { cumulativeAllOutcomes } from 'model/EvidenceSearch'
import OutcomesModel from './model/OutcomesModel'
import { Mode } from './RowComponents'
import OutcomeComponent from './OutcomeComponent'
import Icon from 'components/Icon'
import * as outcomeIcon from 'icons/medical-notes.svg'
import StudySummaryModel from 'components/extract/model/StudySummaryModel'

interface OutcomesListOpts extends ElementProperties<OutcomesMgmtTable> {
	summaryModel: StudySummaryModel
	outcomesModel: OutcomesModel
}

/**
 * Management interface for editing outcome rows themselves
 */
export default class OutcomesMgmtTable extends Table('.outcomes-table') {
	private outcomesModel: OutcomesModel

	created(props: OutcomesListOpts) {
		const { summaryModel, outcomesModel } = props
		const allOutcomes = _.once(() => Array.from(cumulativeAllOutcomes.map.values()))
		props.content = [
			THead([
				TR('.header-row', [
					TH('.outcome-hdr', { attributes: { scope: 'col' } }, 'Outcome'),
					TH('.timepoint-hdr', { attributes: { scope: 'col' } }, 'Followup'),
				])
			]),
			outcomesModel.outcomes.map(outcome => new OutcomeBody({ outcome, summary: summaryModel, outcomesModel, allOutcomes })),
			// TBody('.add-outcome-row', [
			// 	TR([
			// 		TD('.op-cell', { attributes: { colspan: 3 } }, [
			// 			A('.op-link', 'Add Outcome', {
			// 				onclick: e => {
			// 					e.stopPropagation()
			// 					this.addRow()
			// 				}
			// 			})
			// 		])
			// 	])
			// ])
		]
	}

	addRow() {
		this.outcomesModel.addOutcome()
	}

}

class OutcomeBody extends TBody {
	created(props) {
		const { outcome, summary, outcomesModel, allOutcomes } = props
		const comp = new OutcomeComponent({
			summary,
			mode: _if(outcome.property('existing'), [Mode.EDIT, Mode.ADD]),
			outcome,
			outcomes: outcomesModel.outcomes,
			allOutcomes
		})
		props.content = [
			new OutcomeRow({ comp }),
			comp.optionsPanel ? TR('.row-options-row', { classes: { hidden: not(comp.optionsVisible) } }, [
				TD({ attributes: { colspan: 2 } }, [comp.optionsPanel])
			]) : undefined,
		]
	}
}

class OutcomeRow extends TR('.outcome-row') {
	created(props) {
		const comp = props.comp
		props.content = [
			TD('.outcome-cell', { attributes: { scope: 'col' } }, [
				Div([
					comp,
					//Div('.outcome-comparison', { hidden: not(comp.status) }, comp.status.to(s => [Span(s)]))
				])
			]),
			TD('.timepoint-cell', { attributes: { scope: 'col' } },
				comp.timepoint
			)
		]
	}
}